module.exports = __webpack_public_path__ + "static/bg-case5-d4ebfb95e145acb6268b8de2e4972697.png";